<template>
    <router-link
        :to="$trl({
            name: link.page_name,
            params: {
                locale: $route.params.locale
            }
        })"
        ref="link"
        @mousemove.native="handleOver"
        @mouseleave.native="handleLeave"
    >
        <div
            class="image-holder"
        >
            <Parallax
                class="image-gabarit"
                :effect="'translateY'"
                :power="0.0625"
                type="div"
            >

                <div
                    class="image-box"
                    :style="{
                        backgroundImage: `url(${link.image.url})`
                    }"
                />
                <img
                    :src="link.image.url"
                    :alt="link.image.alt"
                    :title="link.image.title"
                    class="seo-image"
                />
            </Parallax>
        </div>
        <LinkHover
            :type="'span'"
            :classNames="{
                default: 'link-default',
                hover: 'link-hover',
                hoverMask: 'link-hover-mask'
            }"
            class="link"
        >
            <div class="default content">
                <span class="caption">{{link.caption}}</span>
                <span class="title">{{link.title}}</span>
                <span class="decoration">
                    <IconPlus/>
                </span>
            </div>
            <template v-slot:hover>
                <div class="hover content">
                    <div class="bg-cross-animated"></div>
                    <span class="caption">{{link.caption}}</span>
                    <span
                        class="title"
                    >{{link.title}}</span>
                    <span class="decoration" ref="decoration">
                        <IconPlus/>
                    </span>
                    <span class="circle" ref="circle"/>
                </div>
            </template>
        </LinkHover>
    </router-link>
</template>
<script>
import LinkHover from '@/components/animation/LinkHover'
import IconPlus from '@/components/IconPlus'
import Parallax from '@/components/animation/Parallax'
import { TweenMax } from 'gsap'
export default {
    components: {
        LinkHover,
        IconPlus,
        Parallax
    },
    props: {
        link: {
            type: Object,
            default() {}
        }
    },
    methods: {
        handleOver(e) {
            const decoration = this.$refs.decoration
            const oX = decoration.offsetLeft + decoration.offsetWidth * 0.5
            const oY = decoration.offsetTop + decoration.offsetHeight * 0.5
            const BBox = this.$el.getBoundingClientRect()
            const x = e.clientX - BBox.left
            const y = e.clientY - BBox.top
            const dx = x / BBox.width - 0.5
            const dy = y / BBox.height - 0.5
            TweenMax.to(this.$refs.circle, .3, {
                x: `${dx * 10}%`,
                y: `${dy * 10}%`
            })
            var dist = Math.sqrt( Math.pow((x - oX), 2) + Math.pow(((y - 485) - oY), 2) );
            if(dist < 350) {
                TweenMax.to(this.$refs.circle, .625, {
                    scale: 1.0,
                    opacity: 1
                })
            } else {
                this.handleLeave()
            }
        },
        handleLeave() {
            TweenMax.killTweensOf(this.$refs.circle)
            TweenMax.to(this.$refs.circle, .625, {
                scale: 0.625,
                opacity: 0.,
                x: '0%',
                y: '0%'
            })
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
a
    flex: 1
    text-decoration: none
    &:hover
        .circle
            transform: scale(1)
            opacity: 1
.image-holder
    padding-bottom: 50.5208333333%
    overflow: hidden
    position: relative
    @include media-breakpoint-down($lg)
        padding-bottom: 64%
.image-gabarit
    position: absolute
    width: 100%
    height: 120%
    top: -10%
    left: 0
.image-box
    width: 100%
    height: 100%
    background-position: 50% 50%
    background-repeat: no-repeat
    background-size: cover
.content
    height: 28.33vw
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    // border: 1px solid #e5e5e5
    background-color: #f1f6f8
    flex: 1
    @include media-breakpoint-up($xxl)
        height: 544px
    @include media-breakpoint-down($lg)
        height: 64vw
.caption
    font-size: 0.8854166667vw
    font-weight: 500
    letter-spacing: -0.03125em
    color: #ff2b2a
    @include media-breakpoint-up($xxl)
        font-size: 25px
    @include media-breakpoint-down($hd)
        font-size: 12px
.title
    font-size: 86px
    font-weight: 500
    letter-spacing: -0.05813953488em
    margin-top: 4%
    margin-bottom: 4%
    @include media-breakpoint-down($hd)
        font-size: 70px
    @include media-breakpoint-down($sm)
        font-size: 35px
.decoration
    /deep/ path
        fill: #ff2b2a
    @include media-breakpoint-down($sm)
        width: 20px
        height: 20px
        /deep/ svg
            width: 100%
            height: 100%
.link
    display: block
    /deep/ .link-default, .hover
        width: 100%
    .hover
        .caption
            color: #FFFFFF
        &.content
            border: none
            background-color: #ff2b2a
            color: #ffffff
        .decoration
            /deep/ path
                fill: #ffffff
.circle
    display: block
    width: 700px
    height: 700px
    border-radius: 50%
    border: 3px solid rgba(255, 255, 255, .1)
    position: absolute
    top: 0
    margin-top: 3%
    pointer-events: none
.bg-cross-animated
    pointer-events: none
</style>
